import { SxProps, Theme } from "@mui/material";

export const modalBoxStyles: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  boxShadow: 24,
  background: "none",
  width: { xs: "90%", sm: "70%", md: "60%" },
};

export const headerStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: theme.palette.recordingsModal.headerBg,
  paddingY: "16px",
  paddingX: "38px",
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
});

export const contentStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  backgroundColor: theme.palette.recordingsModal.background,
  paddingY: "22px",
  paddingX: "38px",
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  overflow: "auto",
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
});

export const blockHeadingStyles: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.modalColors.colorLable,
});

export const statisticsContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(2, minmax(0, 1fr))",
  },
  gap: "16px",
  width: "100%",
  alignItems: "stretch",
});

export const statisticsItemContainerStyles: SxProps<Theme> = (
  theme: Theme
) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  padding: "16px 20px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "12px",
  boxShadow: theme.shadows[1],
  border: `1px solid ${theme.palette.divider}`,
  width: "100%",
  height: "90px",
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
});

export const statisticsItemStyles: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.modalColors.colorLable,
  fontWeight: 600,
  fontSize: { xs: "10px", sm: "12px", md: "14px" },
  flex: 1,
  lineHeight: 1.5,
  wordWrap: "break-word",
  overflowWrap: "break-word",
});

export const statisticsItemValueStyles: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  fontSize: { xs: "10px", sm: "12px", md: "14px" },
  whiteSpace: "nowrap",
  flexShrink: 0,
  alignSelf: "center",
});

export const statisticsIconStyles: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.primary.main,
  fontSize: "24px",
  flexShrink: 0,
});